/**
 * Audit — coreBOS `Audit` (82x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr,nis2,dlgs81. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const auditDescriptor = {
    slug: 'cmp_audit',
    kind: 'document',
    label: { singular: 'Audit', plural: 'Audit' },
    table: 'compliance_audit',
    idStrategy: 'sha256',
    fields: [
        { name: 'auditname', type: 'text', label: 'Nome Audit', required: true },
        { name: 'audit_status', type: 'text', label: 'Stato' },
        { name: 'audittype', type: 'text', label: 'Audittype' },
        { name: 'reference_standard', type: 'text', label: 'Reference standard' },
        { name: 'startdate', type: 'date', label: 'Data Inizio' },
        { name: 'targetenddate', type: 'date', label: 'Targetenddate' },
        { name: 'actualenddate', type: 'date', label: 'Actualenddate' },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'enddate', type: 'date', label: 'Data Fine' },
        { name: 'dvr_revision', type: 'number', label: 'Dvr revision' },
        { name: 'dvr_year', type: 'number', label: 'Dvr year' },
        { name: 'framework_tags', type: 'text', label: 'Framework tags' },
    ],
    relations: [
        { name: 'organization_id', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
        { name: 'documents', kind: 'hasMany', target: 'document' },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true, documents: true },
    ui: { mode: 'generated', icon: 'AuditOutlined', navGroup: 'Audit', lifecycle: { field: 'audit_status', steps: ['Planned', 'In_Progress', 'Completed'] }, deadlines: [{ field: 'targetenddate' }] },
};
